import React, { Component } from "react";
import { Toolbar as ToolbarDHX, awaitRedraw } from "dhx-suite";
import "../../../dhtmlx/codebase/suite.css";
import "./HeaderGrid.css";


class Toolbar extends Component {

	componentDidMount() {
		
		let { css, toogleInput, data } = this.props;
		this.toolbar = new ToolbarDHX(this.el, {
			css: css,
			navigationType: "pointer",
		});
		//configuramos el toolbar
		/**
		 * Nota Hugo 21/10/21
		 * Por alguna razon si le pasamos por props la configuracion los elementos
		 * dentro del toolbar solo se cargan la primera vez, y si nos cambiamos de vista
		 * al regresar este no se carga.
		 * Esta solucion abre la posibilidad a traer asi los componenetes DHTMLX en cada seccion
		 */
		this.toolbar.data.parse(data);

		this.toolbar.events.on("inputChange",(name)=>{
			if(name==='search'){
				toogleInput(this.toolbar.getState());
			}
			
		});
	}
	componentDidUpdate(){
    let { data,gridReady,toogleInput } = this.props;
    if(!gridReady){
      toogleInput(false);
      this.toolbar.data.parse(data);
      let aux = this.toolbar.data.getItem('search');
      aux.val="";

    }
	}
	componentWillUnmount() {
		this.toolbar && this.toolbar.destructor();
	}
	render() {
		return <div style={{ width: "100%" }} ref={el => (this.el = el)}></div>;
	}

}

function ToolbarProps (props){
	
	return (
		<Toolbar 
			css={"dhx_widget--bg_gray"} 
			toogleInput={props.toogleInput}
			actualConcepto={props.actualConcepto}
			gridReady={props.gridReady}
      data={props.data}
		/>);
}

export default ToolbarProps;